'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlbumItemPressIcon = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(AlbumItemPressIcon, _PureComponent);

  function AlbumItemPressIcon() {
    (0, _classCallCheck3.default)(this, AlbumItemPressIcon);
    return (0, _possibleConstructorReturn3.default)(this, (AlbumItemPressIcon.__proto__ || (0, _getPrototypeOf2.default)(AlbumItemPressIcon)).apply(this, arguments));
  }

  (0, _createClass3.default)(AlbumItemPressIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          album = _props.album,
          className = _props.className;


      return _react2.default.createElement(
        'span',
        { className: (0, _bind2.default)({ hidden: !album.isPress }, className) },
        _react2.default.createElement('i', { className: 'icon-paperclip' })
      );
    }
  }]);
  return AlbumItemPressIcon;
}(_react.PureComponent), _class.propTypes = {
  album: _propTypes2.default.object,
  className: _propTypes2.default.string
}, _class.defaultProps = {
  album: {}
}, _temp);
exports.default = AlbumItemPressIcon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AlbumItem/AlbumItemPressIcon/AlbumItemPressIcon.js
// module id = 1946
// module chunks = 1